import {VideoSoundButtonDefaultBox} from "./video-sound-button-default.box";

export const VideoSoundButtonBox = VideoSoundButtonDefaultBox;
